import RoomType from '../roomType';
export default class Outside extends RoomType {
  constructor() {
    super();
    this.id = 'Outside';
    this.name = "Uteareal";
    this.icon = "mdi-tree";
    this.stateQuestions.questions = [
      {
        'id': 'grass',
        'title': 'Gress/ hage',
        'active': true,
        'value': -1
      },
      {
        'id': 'balcony',
        'title': 'Balkonger/ terrasser',
        'active': true,
        'value': -1
      },
      {
        'id': 'gutter',
        'title': 'Takrenner',
        'active': true,
        'value': -1
      },
      {
        'id': 'lights',
        'title': 'Utebelysning',
        'active': true,
        'value': -1
      },
      {
        'id': 'parking',
        'title': 'Parkering',
        'active': true,
        'value': -1
      },
    ];
    this.cleanQuestions.questions = [
      {
        'id': 'door',
        'title': 'Inngangsdør',
        'active': true,
        'value': -1
      },
    ];

    this.contentTypes.options = [
      {
        'id': 'garden',
        'title': 'Hage',
        'active': true,
        'value': -1
      },
      {
        'id': 'parking',
        'title': 'Parkeringsplass',
        'active': true,
        'value': -1
      },
      {
        'id': 'balcony',
        'title': 'Balkong/Terrasse',
        'active': true,
        'value': -1
      },
      {
        'id': 'grill',
        'title': 'Grill',
        'active': false,
        'value': -1
      },
      {
        'id': 'seating',
        'title': 'Sittegruppe',
        'active': false,
        'value': -1
      },
    ];

    this.ceilingTypes = {
      'options': [
        {
          'id': 'panel',
          'title': 'Panel'
        },
        {
          'id': 'plaster',
          'title': 'Gips'
        },
        {
          'id': 'painted',
          'title': 'Malt himling'
        },
        {
          'id': 'ace',
          'title': 'Tak-ess'
        },
      ]
    };
    this.floorTypes = {
      'options': [
        {
          'id': 'stone',
          'title': 'Belegningsstein'
        },
        {
          'id': 'asfalt',
          'title': 'Asfalt'
        },
        {
          'id': 'grass',
          'title': 'Gress'
        },
        {
          'id': 'wood',
          'title': 'Terrassebord'
        },
        {
          'id': 'composit',
          'title': 'Komposittbord'
        },
      ]
    };
    this.wallTypes = {
      'options': [
        {
          'id': 'cladding',
          'title': 'Kledning'
        },
        {
          'id': 'mur',
          'title': 'Murvegg'
        },
        {
          'id': 'composit',
          'title': 'Komposittkledning'
        },
        {
          'id': 'other',
          'title': 'Annet'
        },
      ]
    };
    this.ceilingTypes = {
      'options': []
    };
    this.lightingTypes = {
      'options': [
        {
          'id': 'outside',
          'title': 'Utebelysning - frittstående'
        },
        {
          'id': 'ouside_wall',
          'title': 'Utebelysning - vegglampe'
        },
      ]
    };
    this.heatingTypes = {
      'options': [
        {
          'id': 'gas',
          'title': 'Gassvarmer'
        },
        {
          'id': 'electric',
          'title': 'Elektrisk varmer'
        },
      ]
    };
  }
}